import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import historical from '../assets/images/Riyadh.jpg';


function HistoricalImages() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('Historical')}</h1>
        <img src={historical} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} />
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}><b>{t('Summary')}</b></p>
          
          <p style={{ textAlign: 'justify' }}><b>{t('Description')}</b></p>
        
          <p style={{ textAlign: 'justify' }}>{t('Historical_detailed_info1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('Historical_detailed_info2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('Historical_detailed_info3')}</p>
         
       
          
          <br/> <br/>
      
        <p  style={{ textAlign: 'justify' }}> {t('Historical_Mekkah')} <br/>
        <a href={t('Historical_Mekkah_URL')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
      <br/> 
       
        <p  style={{ textAlign: 'justify' }}> {t('Historical_AlMadinah')} <br/> 
        <a href={t('Historical_AlMadinah_URL')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
      <br/> 
       
        <p  style={{ textAlign: 'justify' }}> {t('Historical_Riyadh')} <br/> 
        <a href={t('Historical_Riyadh_URL')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
      <br/> 
       
        <p  style={{ textAlign: 'justify' }}> {t('Historical_AlUla')} <br/> 
        <a href={t('Historical_AlUla_URL')} download>
        <button className="data-governance-card-link" id="readMoreBtn">{t('Download')}</button>
      </a></p> 
          
      </div> 
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default HistoricalImages;
